module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.drugSetMethod === 'barcode' && _vm.stage === 'selectDrug') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [_c('h3', [_vm._v("請掃描藥單條碼進行"), _c('strong', [_vm._v("退藥")])])])]) : _vm._e(), (_vm.drugSetMethod === 'event' && _vm.stage === 'selectDrug') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "singleSelection": true,
      "noChecked": true
    }
  }) : _vm._e(), (_vm.drugSetMethod === 'returnSchedule' && _vm.stage === 'selectDrug') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "singleSelection": false,
      "number2": _vm.returnScheduleId
    }
  }) : _vm._e(), (_vm.drugSetMethod === 'manual' && _vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "druglist-wrap"
  }, [_c('drugList', {
    attrs: {
      "singleSelection": true
    }
  })], 1) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "startType": _vm.startType,
      "barcodeData": _vm.barcodeData
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData' && _vm.generalSetting.mode === 'aeth') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "病人列表"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'scheduleReturn',
          params: {
            stage: 'ScheduleList'
          }
        })
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "手動退藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDrugSetMethod('manual')
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'setFlowData' && _vm.generalSetting.mode !== 'aeth') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDrugSetMethod('barcode')
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "取藥紀錄"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDrugSetMethod('event')
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始退藥",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06045224","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnDrug.vue
// module id = 1372
// module chunks = 1